import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';
import './BusinessSolutionsHeader.scss';
import { SVGIcon } from '../SVGIcon/SVGIcon';
import { Image } from '../Image/Image';
import logo from '../../images/logo.svg';
import { ROUTES } from '../../lib/constants';
import { Button } from '../Button/Button';

export const scrollToBusinessInquiryForm = (): void => {
  const inquirySection = document.getElementById('business-inquiry-form');
  if (inquirySection) {
    setTimeout(function () {
      inquirySection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 50);
  }
};

export const BusinessSolutionsHeader = (): React.JSX.Element => {
  const [open, setOpen] = useState(false);
  const closeMenu = () => setOpen(false);

  const onInquireToday = () => {
    closeMenu();
    scrollToBusinessInquiryForm();
  };

  return (
    <header>
      <div className='grid-12 header business-solutions-header'>
        <div className='header__left-wrap'>
          <Link className='logo' to={ROUTES.landing.path} aria-label='go to home page' onClick={closeMenu}>
            <Image
              src={logo}
              alt='CitySide Fiber logo'
              width='86'
              height='32'
              loading='lazy'/>
          </Link>
        </div>

        <div className='header__nav-wrap business-solutions-header__nav-wrap' data-open={open}>
          <nav className='business-solutions-nav'>
            <ul>
              <li><a href='#packages' onClick={closeMenu}>Packages</a></li>
              <li><a href='#how-it-works' onClick={closeMenu}>How it Works</a></li>
              <li><a href='#faqs' onClick={closeMenu}>FAQs</a></li>
              <li><Link to={ROUTES.gigInternet.path} onClick={closeMenu}>Home Internet</Link></li>
            </ul>

            <div className='business-solutions-nav__btns'>
              <Button
                className='btn--lg-extra-padding business-solutions-btn bg-color--orange'
                onClick={onInquireToday}
                size='lg'
                fullWidth={true}
              >
                Inquire Today
              </Button>

              <Button
                className='btn--lg-extra-padding business-solutions-btn bg-color--marina-blue'
                path={ROUTES.login.path}
                target='_self'
                size='lg'
                fullWidth={true}
              >
                Log In
              </Button>
            </div>
          </nav>
        </div>

        <div className='header__right-wrap'>
          <Button
            className='btn--lg-extra-padding business-solutions-btn bg-color--orange'
            onClick={onInquireToday}
            size='lg'
          >
            Inquire Today
          </Button>

          <Button
            className='btn--lg-extra-padding business-solutions-btn bg-color--marina-blue'
            path={ROUTES.login.path}
            target='_self'
            size='lg'
          >
            Log In
          </Button>

          <button aria-label={open ? 'close menu' : 'open menu'} onClick={() => setOpen(!open)}>
            <SVGIcon
              id={open ? 'close' : 'menu'}
              color='marina-blue'
            />
          </button>
        </div>
      </div>
    </header>
  )
};
